import axios from './axiosCore';

export function getActions() {
  return axios.get('/api/v2/users/actions');
}
